// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  userId: __t.string().name("user_id"),
  organizationId: __t.string().name("organization_id"),
  inviterId: __t.string().name("inviter_id"),
  inviteToken: __t.string().name("invite_token"),
  isPowerOnProPlus: __t.bool().name("is_power_on_pro_plus"),
  role: __t.string(),
  status: __t.string(),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
